import React from 'react';

const StarIcon = ({ style = {}, strokeWidth = 0, stroke = 'white', rounded, color, color2, shadow, width, viewBox = '0 0 1000 1000' }) => {
  const fill = shadow ? 'black' : color ? (color2 ? 'url(#mt_star-gradient)' : color) : 'none';
  const points = '500,76 605,400 938,400 670,597 779,923 500,723 221,923 330,597 62,400 395,400';

  return (
    <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="mt_star-gradient" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
          <stop offset="0%" stopColor={color} />
          <stop offset="100%" stopColor={color2} />
        </radialGradient>
      </defs>
      <polygon stroke={stroke} strokeLinejoin={rounded ? 'round' : ''} strokeWidth={strokeWidth * 10} points={points} fill={fill} />
    </svg>
  );
};

export default StarIcon;
